import { useAuthStore } from '~/stores/auth'
import { useAlertStore } from '~/stores/alert'
import { checkPendingInvites } from '~/composables/useInviteCheck'
import { ensureEventContext } from '~/composables/useEnsureEventContext'
const { me } = useAuth()

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  await me()
  const { user, isViewer } = useAuthStore()
  const alertStore = useAlertStore()

  if (isViewer)
    return true

  try {
    await ensureEventContext()
  } catch {
    // Hydration failure is non-fatal; user-scoped checks below don't need eventId.
  }

  // Check for Participant-based invites (new event system)
  try {
    const result = await checkPendingInvites()
    if (result === 'pending') return navigateTo('/accept-invite')
    if (result === 'active') return true
  } catch {
    // Fall through to old system check
  }

  if (user?.yearsInvited) {
    if (!user.yearsInvited[0].accepted) {
      return navigateTo('/new-welcome/back')
    }
    return true
  }

  alertStore.setAlert('You are not authorized to view this page since you are not invited to the current year', 'error')
  return navigateTo('/')
})